<template>
  <div class="bgImage" :style="imageStyle">
    <!--img :src="path" width="0" height="0" ref="img"-->
  </div>
</template>

<script>

export default {
  props: {
    path: {
      type: String,
      required: true,
      default: '',
    },
    hotspot: {
      type: Object,
      default() {
        return { x: 50, y: 50 };
      },
      required: false,
    },
  },
  daata() {
    return {
      imageSize: {
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    imageStyle() {
      return {
        backgroundImage: `url("${this.path}")`,
        backgroundPositionX: `${this.hotspot.x}%`,
        backgroundPositionY: `${this.hotspot.y}%`,
      };
    },
  },
  /* updated() {
    console.log(`${this.path} ${this.$refs.img.naturalWidth} x ${this.$refs.img.naturalHeight}`);
    console.log(this.$el.clientWidth);
  }, */
};
</script>

<style lang="scss">
.bgImage {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
@media (prefers-color-scheme: dark) {
  .bgImage {
    opacity: .7;
  }
}
</style>
